import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/object-ungroup': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M564 224C570.6 224 576 218.6 576 212V140C576 133.4 570.6 128 564 128H492C485.4 128 480 133.4 480 140V152H392V128H404C410.6 128 416 122.6 416 116V44C416 37.4 410.6 32 404 32H332C325.4 32 320 37.4 320 44V56H96V44C96 37.4 90.6 32 84 32H12C5.4 32 0 37.4 0 44V116C0 122.6 5.4 128 12 128H24V288H12C5.4 288 0 293.4 0 300V372C0 378.6 5.4 384 12 384H84C90.6 384 96 378.6 96 372V360H184V384H172C165.4 384 160 389.4 160 396V468C160 474.6 165.4 480 172 480H244C250.6 480 256 474.6 256 468V456H480V468C480 474.6 485.4 480 492 480H564C570.6 480 576 474.6 576 468V396C576 389.4 570.6 384 564 384H552V224H564zM352 64H384V96H352V64zM352 320H384V352H352V320zM64 352H32V320H64V352zM64 96H32V64H64V96zM96 312V300C96 293.4 90.6 288 84 288H72V128H84C90.6 128 96 122.6 96 116V104H320V116C320 122.6 325.4 128 332 128H344V288H332C325.4 288 320 293.4 320 300V312H96zM224 448H192V416H224V448zM504 384H492C485.4 384 480 389.4 480 396V408H256V396C256 389.4 250.6 384 244 384H232V360H320V372C320 378.6 325.4 384 332 384H404C410.6 384 416 378.6 416 372V300C416 293.4 410.6 288 404 288H392V200H480V212C480 218.6 485.4 224 492 224H504V384zM544 448H512V416H544V448zM544 192H512V160H544V192z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/object-ungroup.js
// module id = /YNi
// module chunks = 144